import { useEffect } from 'react'
import BottomSheetContent from '../BottomSheetContent'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { GRAND_FATHERING_HEADING_ID } from './grandFatheringConstants'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

export const GrandFathering = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Tax grandfathering rule'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent heading={heading} headingId={GRAND_FATHERING_HEADING_ID} onDismiss={onDismiss}>
      {/* Separate paragraphs: a text-only block with <br /> becomes one TalkBack stop that reads everything */}
      <div className='text-[#6A6E6E] leading-[150%] text-[14px] space-y-[1.5em]'>
        <p>For equity-oriented funds, gains made before 31 Jan 2018 on equity mutual funds aren’t taxed.</p>
        <p>
          If you invested before this date, your cost price is taken as the higher of your actual purchase price or the
          NAV on 31 Jan 2018.
        </p>
        <p>So only gains after 31 Jan 2018 are taxable.</p>
      </div>
    </BottomSheetContent>
  )
}
